import React from 'react';

import { ReactComponent as MoteIcon } from '@assets/svg/devices/ic-mote.svg';
import { ReactComponent as SensorIcon } from '@assets/svg/devices/ic-sensor.svg';

import style from './style.module.scss';

interface IProps {
  type?: string;
  partNumber?: string;
}

export const TYPE_ICON = {
  mote: MoteIcon,
  sensor: SensorIcon,
};

const SensorType: React.FC<IProps> = ({ type, partNumber }) => {
  const sensorType = type === 'boolean' ? 'sensor' : type || 'sensor';
  const TypeIcon = TYPE_ICON[sensorType as keyof typeof TYPE_ICON];

  return (
    <div className={style.typeWrapper}>
      <TypeIcon className={style.typeIcon} />
      <span className={style.typeName}>{sensorType}</span>
      {partNumber && <span className={style.partNumberInfo}>{partNumber}</span>}
    </div>
  );
};

export default SensorType;
